import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class CustomDateAdapterService extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[2], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[0], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (date) {

      let month: string = date.month.toString().length == 1 ? `0${date.month}` : date.month.toString()
      let day: string = date.day.toString().length == 1 ? `0${date.day}` : date.day.toString()
      return date ? date.year
        + this.DELIMITER + month
        + this.DELIMITER + day : null
    }
    return null
  }
}
